// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(ids-draggable) {
  height: fit-content;
  width: fit-content;
}

:host(ids-draggable:not([handle])) {
  cursor: var(--ids-cursor-move);
  touch-action: none;
}

:host(ids-draggable[disabled]:not([handle])) {
  cursor: inherit;
}

:host(ids-draggable[axis=x]:not([disabled])) {
  cursor: var(--ids-cursor-resize-x);
}

:host(ids-draggable[axis=y]:not([disabled])) {
  cursor: var(--ids-cursor-resize-y);
}

ids-draggable[is-dragging]:not([handle]) {
  cursor: var(--ids-cursor-grabbing);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-draggable/ids-draggable.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF","sourcesContent":[":host(ids-draggable) {\n  height: fit-content;\n  width: fit-content;\n}\n\n:host(ids-draggable:not([handle])) {\n  cursor: var(--ids-cursor-move);\n  touch-action: none;\n}\n\n:host(ids-draggable[disabled]:not([handle])) {\n  cursor: inherit;\n}\n\n:host(ids-draggable[axis='x']:not([disabled])) {\n  cursor: var(--ids-cursor-resize-x);\n}\n\n:host(ids-draggable[axis='y']:not([disabled])) {\n  cursor: var(--ids-cursor-resize-y);\n}\n\nids-draggable[is-dragging]:not([handle]) {\n  cursor: var(--ids-cursor-grabbing);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
